import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import bottomArrow from '../../../../global/media/bottom-arrow.svg';
import { selectors } from '../../reducer';
import * as actions from '../../actions';

import RxGateReceiptTable from '../RxGateReceiptTable';

const RxGaterxGateChosenReceiptBlock: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const rxGateCurrentReceiptError = useSelector(
    selectors.rxGateCurrentReceiptError
  );
  const rxGateCurrentReceiptLoading = useSelector(
    selectors.rxGateCurrentReceiptLoading
  );
  const rxGateReceiptLastUpdate = useSelector(
    selectors.rxGateReceiptLastUpdate
  );
  const rxGateChosenReceipt = useSelector(selectors.rxGateChosenReceipt);
  const applyRecipeResult = useSelector(selectors.applyRecipeResult);

  useEffect(() => {
    if (!rxGateCurrentReceiptError) return;
    dispatch(actions.setRxGateChosenReceipt.request(null));
  }, [rxGateCurrentReceiptError]);

  const getReceiptErrText = useMemo(() => {
    if (!rxGateChosenReceipt?.docErr) return null;

    switch (rxGateChosenReceipt.docErr.code) {
      case 'no_products':
      case 'too_much_products':
      case 'contains_error_products':
        return t(
          `RXGatePage.Receipt_errors.${rxGateChosenReceipt.docErr.code.toUpperCase()}`
        );

      default:
        return rxGateChosenReceipt.docErr.code;
    }
  }, [rxGateChosenReceipt]);

  if (!rxGateChosenReceipt) return null;

  return (
    <>
      <div className="active-receipt-top">
        <div className="left-block">
          {!applyRecipeResult && (
            <div
              className="back-to-reciepts"
              onClick={() => {
                dispatch(actions.setRxGateChosenReceipt.request(null));
              }}
            >
              <img
                className="back-to-reciepts-icon"
                src={bottomArrow}
                alt="back-to-reciepts-icon"
              />
              {t('LoyaltyPage.BACK_TO_RECEIPTS')}
            </div>
          )}
          <div className="last-update">
            {t('LoyaltyPage.LAST_UPDATE')}{' '}
            {rxGateCurrentReceiptLoading ? (
              <CircularProgress size={15} />
            ) : (
              rxGateReceiptLastUpdate
            )}
          </div>
          {rxGateChosenReceipt.docErr && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <img
                src="/images/client_not_added.png"
                width={20}
                height={20}
                alt="icon"
              />
              {getReceiptErrText}
            </div>
          )}
        </div>
      </div>

      <RxGateReceiptTable currentReceipt={rxGateChosenReceipt.products} />
    </>
  );
};

export default RxGaterxGateChosenReceiptBlock;
